import React from "react";
import images from "../../../../utilities/images/images";
import "./HeaderInstruction.css";

function HeaderInstruction({
  name,
  type,
  duration,
  totalQuestions,
  maxMarks,
  date,
  image,
  duration_icon,
  paper_icon,
  question_icon,
}) {
  return (
    <div className="test_instruction_card">
      <div className="left_icon_box">
        <img src={paper_icon} alt="" className="calendar_icon" />
      </div>
      <div className="middle_content">
        <div className="title_block">
          <div className="title_name">{name}</div>
          <div className="title_subtitle">{type}</div>
        </div>

        <div className="details_row">
          <div className="detail_item">
            <img
              src={duration_icon || images.duriation_icon}
              className="detail_icon"
              alt="duriation_icon"
            />
            <div>
              <p className="detail_label">Duration</p>
              <p className="detail_value">{duration} mins</p>
            </div>
          </div>

          <div className="detail_item">
            <img src={question_icon} className="detail_icon" alt="" />
            <div>
              <p className="detail_label">Questions</p>
              <p className="detail_value">{totalQuestions}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="right_image_box">
        {/* <img src={image} alt="" className="approved_image" /> */}
        <img src={images.approved_list} alt="" className="approved_image" />
      </div>
    </div>
  );
}

export default HeaderInstruction;
